import { defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import SubFooter from './sub-footer';
import MainFooter from './main-footer';
import React from 'react';

const Inspector = React.lazy(() => import('./Inspector'));

function Footer({ menu, subMenu, btnLink, btnText, tel, linkLinkedin }) {
    useInspectorControl(Inspector);

    return (
        <>
            <MainFooter menu={menu} btnLink={btnLink} btnText={btnText} tel={tel} linkLinkedin={linkLinkedin} />
            <SubFooter menu={subMenu} />
        </>
    );
}

export default defineBlock({
    Block: Footer,
    smartProps: {
        logo: smartProps.image,
        btnLink: smartProps.string.withDefault(''),
        btnText: smartProps.string.withDefault('Texte du bouton'),
        openings: smartProps.string.withDefault(''),
        tel: smartProps.string.withDefault(''),
        linkLinkedin: smartProps.string.withDefault(''),
        certifications: smartProps.image,
    },
    setup: {
        title: 'Footer',
    },
});
